import React from 'react'
import { Modal, Button, Table, Spinner } from "react-bootstrap";

const CompanyCertificationModal = ({ show, onHide, data, loading }) => {
    console.log("data", data);
  return (
     <Modal show={show} onHide={onHide} centered size="lg">
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title>Certificate Details</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            {loading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">Loading certificate details...</p>
              </div>
            ) : data ? (
              <Table bordered hover responsive className="certificate-table">
                <tbody>
                  <tr>
                    <th>Company Name</th>
                    <td>{data.companyName}</td>
                  </tr>
                  <tr>
                    <th>Certificate No</th>
                    <td>{data.certificationNumber}</td>
                  </tr>
                  {/* <tr>
                    <th>Country</th>
                    <td>{data.country}</td>
                  </tr> */}
                  <tr>
                    <th>Company Address</th>
                    <td>{data.address}</td>
                  </tr>
                  {/* {data.CompanyAddress2 && (
                    <tr>
                      <th>Company Address 2</th>
                      <td>{data.companyAddress2}</td>
                    </tr>
                  )} */}
                  <tr>
                    <th>Standard</th>
                    <td>{data.standard}</td>
                  </tr>
                  <tr>
                    <th>Date of Registration</th>
                    <td>
                      {data.dateOfRegistration
                        ? new Date(data.dateOfRegistration).toLocaleDateString()
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Next Audit Due Date</th>
                    <td>
                      {(() => {
                        // normalize case (handles 'Completed', 'completed', etc.)
                        const firstStatus = (
                          data.firstSurveillanceStatus || ""
                        ).toLowerCase();
                        const secondStatus = (
                          data.secondSurveillanceStatus || ""
                        ).toLowerCase();
    
                        // format helper
                        const formatDate = (value) => {
                          if (!value) return "—";
                          const d = new Date(value);
                          return isNaN(d.getTime()) ? "—" : d.toLocaleDateString();
                        };
    
                        // logic based on your rule
                        if (firstStatus !== "completed") {
                          return formatDate(data.firstSurveillanceAudit);
                        } else if (secondStatus !== "completed") {
                          return formatDate(data.secondSurveillanceAudit);
                        } else {
                          return formatDate(data.certificationExpiryDate);
                        }
                      })()}
                    </td>
                  </tr>
    
                  <tr>
                    <th>Re Certification Date</th>
                    <td>
                      {data.certificationExpiryDate
                        ? new Date(
                            data.certificationExpiryDate
                          ).toLocaleDateString()
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Scope</th>
                    <td>{data.scopeOfWork}</td>
                  </tr>
                  <tr>
                    <th>Certificate Status</th>
                    <td>{data.status}</td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <div className="text-center text-muted py-3">
                No certificate details found.
              </div>
            )}
          </Modal.Body>
    
          <Modal.Footer>
            <Button variant="secondary" onClick={onHide}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
  )
}

export default CompanyCertificationModal
